export enum RouterHeorotPagesEnum {
  Dashboard = '/',
  Planning = 'planning',
  Results = 'results',
  PlanningAndResults = 'planning-and-results',
  Settings = 'settings',
}
